import React from 'react';
import { Shield } from 'lucide-react';
import { ProgressBar } from '../../../ui';
import IconChip from '../shared/IconChip';
import { levelPct } from '../studentHomeRules';

const LevelCard = ({ level }) => (
  <section aria-label="Your level" className="tw-cq-card tw-flex tw-min-w-0 tw-flex-col tw-justify-between tw-gap-2.5 tw-rounded-lg tw-border tw-border-solid tw-border-line tw-bg-surface-raised tw-p-3.5 tw-shadow-card page-sm:tw-p-4">
    <div className="tw-flex tw-items-start tw-justify-between tw-gap-2">
      <div className="tw-min-w-0">
        <div className="tw-text-[0.6875rem] tw-uppercase tw-tracking-caps tw-text-content-subtle">Current Level</div>
        <div className="tw-mt-1 tw-text-xl tw-font-medium tw-leading-tight tw-text-content">Level {level.current}</div>
        <div className="tw-mt-1 tw-hidden tw-text-xs tw-text-content-muted card-xs:tw-block">
          Keep learning to reach Level {level.current + 1}
        </div>
      </div>
      <IconChip icon={Shield} size={34} className="tw-hidden card-xs:tw-inline-flex" />
    </div>
    <div>
      <ProgressBar value={levelPct(level)} size="md" color="primary" />
      <div className="tw-mt-1.5 tw-text-xs tw-font-semibold tw-text-content-muted">{level.xp} / {level.xpToNext} XP</div>
    </div>
  </section>
);

export default LevelCard;
